<div class="page-title-area"  >
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                 
                 
                    <ul>
                        <li><a routerLink="/job-list">Dashboard</a></li>
  
            
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Mi Profile</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="dashboard-area pt-100" [formGroup]="form">
    <div class="container">
        <div class="row align-items-center">
         <div class="col-lg-12">
                <div class="dashboard-img">
                   <!--- <img src="assets/img/dashboard/1.jpg" alt="Dashboard"> -->
                   <button class="btn create-ac-btn">Codigo di Usuario: #{{userInfo?.id}}</button>
                    
                </div>
            </div>
       

            <app-dashpills></app-dashpills>

        </div>


        <!-- Basic Information Section -->
        <div class="create-information">
            <h3>Informashon Basiko</h3>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Nòmber</label>
                        <input type="text" class="form-control" placeholder="Nomber" formControlName="firstname">
                        <div *ngIf="form.get('firstname').touched && form.get('firstname').errors" class="text-danger">
                            <div *ngIf="form.get('firstname').errors['required']">Nòmber is required.</div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Fam</label>
                        <input type="text" class="form-control" placeholder="Fam" formControlName="lastname">
                        <div *ngIf="form.get('lastname').touched && form.get('lastname').errors" class="text-danger">
                            <div *ngIf="form.get('lastname').errors['required']">Fam is required.</div>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Fecha di Nasementu</label>
                        <input type="text" class="form-control" placeholder="dia / luna / aña" formControlName="dob">
                        <div *ngIf="form.get('dob').touched && form.get('dob').errors" class="text-danger">
                            <div *ngIf="form.get('dob').errors['required']">Fecha di Nasementu is required.</div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Estado di Trabou:</label>
                        <select class="form-control" formControlName="employment_status">
                            <option value="">Select...</option>
                            <option value="Mi tin trabou">Mi tin trabou</option>
                            <option value="Mi no tin trabou">Mi no tin trabou</option>
                            <option value="studiante">Studiante</option>
                        </select>
                        <div *ngIf="form.get('employment_status').touched && form.get('employment_status').errors" class="text-danger">
                            <div *ngIf="form.get('employment_status').errors['required']">Estado di Trabou is required.</div>
                        </div>
                    </div>
                </div>

                <!-- Sex Radio Buttons -->
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Sekso</label>
                        <div class="gender-area">
                            <div>
                                <input type="radio" id="male" formControlName="sex" value="male">
                                <label for="male">Maskulino</label>
                            </div>
                            <div>
                                <input type="radio" id="female" formControlName="sex" value="female">
                                <label for="female">Femenino</label>
                            </div>
                        </div>
                        <div *ngIf="form.get('sex').touched && form.get('sex').errors" class="text-danger">
                            <div *ngIf="form.get('sex').errors['required']">Sekso is required.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Education Section -->
        <div formArrayName="education">
            <div class="create-education create-education-two" >
                <div class="create-education-wrap">
                    <div class="create-education-left">
                        <h3>Edukashon</h3>
                    </div>

                    <div class="create-education-right">
                        <a type="button" (click)="addEducation()">
                          <i class="icofont-plus-circle"></i> 
                        </a>
                      </div>
                </div>

           
                   <div class="row" *ngFor="let education of educationFormArray.controls; let i = index" [formGroupName]="i">
                


                        <div class="col-lg-2">
                            <div class="form-group">
                                <label >Nivel di estudio</label> 
                                <div class="form-group">
                                    <select formControlName="level" class="form-control" style="width: 100%; color:#0a213c">
                                    <option value="Sertifikado">Sertifikado</option>
                                    <option value="VSBO-PBL">VSBO-PBL</option>
                                    <option value="VSBO-PKL">VSBO-PKL</option>
                                    <option value="VSBO-TKL">VSBO-TKL</option>
                                    <option value="LTS">LTS</option>
                                    <option value="MAVO">MAVO</option>
                                    <option value="HAVO">HAVO</option>    
                                    <option value="VWO">VWO</option>    
                                    <option value="SBO">SBO / MBO</option>
                                    <option value="HBO">HBO</option>
                                    <option value="WO">WO</option>
                                </select>
                            </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Instituto</label>
                                <input type="text" class="form-control" placeholder="Nomber di instituto" formControlName="institute">
                            </div>
                        </div>

                        <div class="col-lg-2">
                            <div class="form-group">
                                <label>Mi a start: </label> 
                                <select class="form-control" formControlName="startYear" class="form-control">
                                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                                  </select>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                               
                               <label>Mi a stòp: </label> 
                                <select class="form-control" formControlName="endYear" class="form-control" id="teku">
                                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                                  </select>
                            </div>
                        </div>
                        <div class="col-lg-1">
                            <div class="form-group">
                                <label class="form-check-label" for="flexCheckDefault">Finalisá?</label> <br />
                                <!-- Inside your *ngFor loop for educations -->
<input type="checkbox" class="form-check-input" id="flexCheckDefault" formControlName="isFinished" style="width: 30px; height: 30px;">

                            
                            </div>
                        </div>
                        <div class="col-lg-1">
                            <div class="form-group">
                             <!---   <a (click)="removeEducation(i)"> <i class="icofont-trash"></i>  </a> -->
                            
                            </div>
                        </div>

                    </div>
                
            </div>
</div>
        <!-- Work Experience Section -->
        <div class="create-skills">
            
            <div class="create-skills-wrap" formArrayName="workExperiences">
                <h3>Eksperensia di Trabou</h3>
                <div class="create-skills-right"> 
                    
                    <a type="button" (click)="addWorkExperience()" class="mb-5">
                    <i class="icofont-plus-circle"></i> </a>
       
            
               
                <div *ngFor="let work of workExperienceFormArray.controls; let j = index" [formGroupName]="j">
                    
                    <div class="row">
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label>Negoshi</label>
                            <input type="text" class="form-control" placeholder="Nomber di negoshi" formControlName="company">
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label>Puesto:</label>
                            <input type="text" class="form-control" placeholder="Puesto" formControlName="position">
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="form-group">
                            <label>Kuminsá na:</label>
                            <select formControlName="startYear" class="form-control">
                                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                              </select>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="form-group">
                            <label for="teku">Te ku:</label>
                            <select formControlName="endYear" class="form-control">
                                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                              </select>
                             
                        </div>
                        
                    </div>
                    <div class="col-lg-2">
                        <div class="form-group">
                           <a (click)="removeWorkExperience(j)"> <i class="icofont-trash"></i>  </a>
                             
                        </div>
                        
                    </div>
                </div>
                </div>

            </div>
            </div>

            <form>
                <div class="row">
        

                
                   
                </div>
            </form>
        </div>

        <!-- Submit Button -->
        <div class="text-right">
            <button (click)="submitUserProfile()" class="btn create-ac-btn">Save Profile</button>
        </div>
    </div>
</div>
